// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { yearsToMonths as fn } from "../yearsToMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const yearsToMonths = convertToFP(fn, 1);

// Fallback for modularized imports:
export default yearsToMonths;
